<template>
    <v-container fluid id="outline" class="py-15">
        <v-layout v-bind="binding">
            <v-flex xs12 class="text-center">
                <div class="mx-auto font-weight-light mt-10">
                    <p class="subtitle-1 font-weight-bold">{{$t("LP.credit.organizer")}}
                    </p>
                    <a :href="ad_url" target="_blank">
                        <v-img :src="ad_logo" max-width="300px" class="mx-auto mt-4"></v-img>
                    </a>
                </div>

                <div class="mx-auto font-weight-light mt-10">
                    <p class="subtitle-1 font-weight-bold mt-5">{{$t("LP.credit.direction")}}
                    </p>
                    <a :href="rail_url" target="_blank">
                        <v-img :src="rail_logo" max-width="300px" class="mx-auto"></v-img>
                    </a>
                </div>

                <div class="mx-auto font-weight-light mt-10">
                    <p class="subtitle-1 font-weight-bold mt-5">{{$t("LP.credit.technical")}}
                    </p>
                    <a :href="syn_url" target="_blank">
                        <v-img :src="syn_logo" max-width="300px" class="mx-auto mt-4"></v-img>
                    </a>
                </div>

                <div class="mx-auto font-weight-light mt-10">
                    <p class="subtitle-1 font-weight-bold">{{$t("LP.credit.support")}}</p>
                    <a :href="vive_url" target="_blank">
                        <v-img :src="vive_logo" max-width="200px" class="mx-auto mt-4"></v-img>
                    </a>
                </div>

                <div class="mx-auto font-weight-light mt-10">
                    <p class="subtitle-1 font-weight-bold mb-5">{{$t("LP.credit.project")}}</p>
                    <a :href="corporate_url" target="_blank">
                        <v-img :src="cp_logo_w" max-width="300px" class="mx-auto">
                        </v-img>
                    </a>
                    <p class="text-subtitle-2 mt-5">NAKED, INC. (株式会社ネイキッド)</p>
                    <p class="text-caption text-sm-body-1 text-block mx-auto mt-7" v-html="$t('LP.credit.caption')">
                    </p>
                    <a class="body-1" href="https://naked.co.jp" target="_blank"
                        style="color:#fff;">https://naked.co.jp</a>
                </div>

            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        data: () => ({
            corporate_url: 'https://naked.co.jp',
            cp_logo_w: './Images/NAKED,INC._Logotype_w.svg',
            rail_url: 'https://www.keikyu.co.jp/',
            rail_logo: './Images/logo/logo_keikyu-railway.png',
            ad_url: 'https://www.keikyu-ad.co.jp/',
            ad_logo: './Images/logo/logo_keikyu-ad.png',
            syn_url: 'https://synesthesias.jp/',
            syn_logo: './Images/logo/logo_synesthesias.png',
            vive_url: 'https://www.vive.com/jp/',
            vive_logo: './Images/logo/logo_vive.png',
        }),
    }
</script>